import { action } from 'satcheljs';

export default action('SET_OPTIONS_SEARCH_TERM', (query: string) => ({ query }));
